module.exports = __webpack_public_path__ + "static/sf_9.35bca627.png";